import {Component, effect, inject, OnInit, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonButton, IonIcon, IonSelect, IonSelectOption} from '@ionic/angular/standalone';
import {PropertyService} from '../../properties/property.service';
import {components} from '../../configs/config';
import {LanguageService} from '../../core/language.service';
import {FilterService} from '../filter/filter.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-header-filter',
  templateUrl: './header-filter.component.html',
  styleUrls: ['./header-filter.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    FormsModule,
    IonButton,
    IonIcon,
    IonSelect,
    IonSelectOption,
    ReactiveFormsModule
  ],
  standalone: true
})
export class HeaderFilterComponent  implements OnInit {
  propertyService: PropertyService = inject(PropertyService);
  languageService: LanguageService = inject(LanguageService);
  content: any;

  filterForm: FormGroup = new FormGroup({
    city: new FormControl(),
    beds: new FormControl(0),
    baths: new FormControl(0),
    sub: new FormControl(''),
    category: new FormControl(''),
    unfurnished: new FormControl(),
    partiallyFurnished: new FormControl(),
    fullyFurnished: new FormControl(),
    withAppliances: new FormControl(),
    withOutAppliances: new FormControl(),
  });
  filterService: FilterService = inject(FilterService);
  router: Router = inject(Router);
  constructor() {
    effect(() => {
      if (this.filterService.filterData()) {
        const data = this.filterService.filterData();
        this.filterForm.patchValue({
          sub: data.sub,
          city: data.city,
          }, {emitEvent: false});
      }
    });
  }

  async ngOnInit() {

    if (this.languageService.lang()) {
      this.content = await this.languageService.loadContent(components.filters);
    }
  }
  filterProperties() {
    const values: any = {};
    if (this.propertyService.selectedCategory()) {
      values.subCatId = this.filterForm.value.category;
    }

    const formValues = { ...this.filterForm.value };
    if (formValues.beds === 0) delete formValues.beds;
    if (formValues.baths === 0) delete formValues.baths;
    if (!formValues.sub) delete formValues.sub;
    if (!formValues.category) delete formValues.category;

    const queryParams = { ...values, ...formValues };
    this.filterService.filterData.set(queryParams);

    const url = new URL('https://listings.satel.sa');
    Object.entries(queryParams).forEach(([key, value]) => {
      if (value != null && value !== '' && value !== false) {
        url.searchParams.append(key, String(value));
      }
    });

    window.location.href = url.toString();
  }


}
